export enum SORTING_OPTIONS_TRIPLE_PLAY {
  Recommended = 0,
  Year_Price = 1,
  Month_Price = 2,
  Speed = 3,
}

export const SORTING_DESCENDING_ORDER_TRIPLE_PLAY = {
  [SORTING_OPTIONS_TRIPLE_PLAY.Recommended]: false,
  [SORTING_OPTIONS_TRIPLE_PLAY.Year_Price]: false,
  [SORTING_OPTIONS_TRIPLE_PLAY.Month_Price]: false,
  [SORTING_OPTIONS_TRIPLE_PLAY.Speed]: true,
};

export const SORTING_REFERENCE_TRIPLE_PLAY = {
  [SORTING_OPTIONS_TRIPLE_PLAY.Recommended]: 'recommendation',
  [SORTING_OPTIONS_TRIPLE_PLAY.Year_Price]: 'priceInfo.totalFirstYearCost',
  [SORTING_OPTIONS_TRIPLE_PLAY.Month_Price]: 'priceInfo.total',
  [SORTING_OPTIONS_TRIPLE_PLAY.Speed]: 'downloadSpeedInMb',
};
